import { render } from "./ProgramDetail.vue?vue&type=template&id=4365491a&scoped=true"
import script from "./ProgramDetail.vue?vue&type=script&lang=js"
export * from "./ProgramDetail.vue?vue&type=script&lang=js"

import "./ProgramDetail.vue?vue&type=style&index=0&id=4365491a&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4365491a"],['__file',"resources/js/components/ProgramDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4365491a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4365491a', __exports__)) {
    api.reload('4365491a', __exports__)
  }
  
  module.hot.accept("./ProgramDetail.vue?vue&type=template&id=4365491a&scoped=true", () => {
    api.rerender('4365491a', render)
  })

}


export default __exports__